import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../App/Models/NotificationDuration';
import { AppService, DomainTypes, Types } from '../../DomainTypes';
import InterestRateCalculationType from '../../Models/Rates/InterestRateCalculationType';

@NeoModel
export default class InterestRateCalculationTypesVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private investmentSetupApiClient = AppService.get(DomainTypes.ApiClients.InvestmentSetup),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)) {

        super(taskRunner);

        this.fetchInterestRateCalculationTypes = this.fetchInterestRateCalculationTypes.bind(this);
    }

    public interestRateCalculationTypeList = new List(InterestRateCalculationType);

    public get isDirty() {
        return this.editingInterestRateCalculationType?.isDirty ?? false;
    }

    public async fetchInterestRateCalculationTypes() {
        const data = await this.taskRunner.waitForData(this.investmentSetupApiClient.getInterestRateCalculationTypes());
        this.interestRateCalculationTypeList.set(data);
    }

    public editingInterestRateCalculationType: InterestRateCalculationType | null = null;

    public async beginEditingInterestRateCalculationType(interestRateCalculationType: InterestRateCalculationType) {

        this.editingInterestRateCalculationType = interestRateCalculationType;
    }

    public async deleteInterestRateCalculationType(interestRateCalculationTypeId: number) {
        
        this.taskRunner.run(async () => {
            await this.investmentSetupApiClient.deleteInterestRateCalculationType(interestRateCalculationTypeId);
            this.interestRateCalculationTypeList.removeWithoutTracking(this.interestRateCalculationTypeList.find(calcType => calcType.interestRateCalculationTypeId === interestRateCalculationTypeId)!);
            this.notifications.addSuccess("Interest Rate Calculation Type", "Deleted successfully.", NotificationDuration.Standard);
        });
    }

    public newInterestRateCalculationType() {
        this.editingInterestRateCalculationType = new InterestRateCalculationType();
    }

    public async saveInterestRateCalculationType() {
        
        this.taskRunner.run(async () => {
            if (this.editingInterestRateCalculationType) {

                const result = await this.investmentSetupApiClient.saveInterestRateCalculationType(this.editingInterestRateCalculationType.toJSObject());
                if (this.editingInterestRateCalculationType.isNew) {
                    this.editingInterestRateCalculationType.update(result.data);
                    this.interestRateCalculationTypeList.push(this.editingInterestRateCalculationType);
                }
                else {
                    this.editingInterestRateCalculationType.update(result.data);
                }
                this.notifications.addSuccess("Interest Rate Calculation Type", "Saved successfully.", NotificationDuration.Standard);
                this.editingInterestRateCalculationType = null;
                this.dataCache.interestRateCalculationTypes.expire();
            }
        });
    }
}